import type { FetchQueryOptions, QueryKey } from "@tanstack/vue-query";
import { getQueryClient } from "@verbleif/lib/src/composables/Query/queryClient";

/**
 * Imperative fetchQuery with networkMode "always" and retry false by default.
 * Use for one-shot reads that must not pause offline or retry like useQuery.
 * Callers may override networkMode / retry.
 */
export function fetchQueryOnce<
  TQueryFnData,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: FetchQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): Promise<TData> {
  return getQueryClient().fetchQuery({
    networkMode: "always",
    retry: false,
    ...options,
  });
}
